/**
 * Cribbed from datacenter.js. Parses simple markdown.
 * @param {string} txt - Directly from the google sheet cell
 * @return {string} - markdown->html string
 */
export default function markdown() {
  return function(txt) {
    if (txt === null) {
      return txt;
    }

    let _txt = txt;
    // parse the string otherwise do it recursively
    if (typeof _txt !== 'string') {
      Object.keys(_txt).forEach(i => {
        _txt[i] = markdown()(_txt[i]);
      });
      return _txt;
    }
    _txt = _txt
      .replace(/(^|\W)\*(.*?)\*($|\W)/mg, '$1<strong>$2</strong>$3')
      .replace(/(^|\W)_(.*?)_($|\W)/mg, '$1<em>$2</em>$3')
      .replace(/\[(.*?)\]\((.*?)\)/mg, '<a href="$2" target="_self">$1</a>')
      .replace(/\n\s*\n\s*/mg, '</p><p>');
    return `<p>${_txt}</p>`;
  };
}



// WEBPACK FOOTER //
// ../datacenter/app/js/filters/markdownFilter.js